import { Redirect } from 'react-router-dom';
import { useRecoilValue } from 'recoil';

import * as K from 'common/constants';
import AccessDeniedError from 'components/common/AccessDeniedError/AccessDeniedError';
import { homePageState } from 'components/common/Router/Router.state';
import { homepageIsValidState, userTeamHomepageState } from 'components/common/Managers/PreferencesManager.state';

function RedirectToHomePage() {
  const defaultHomepage = useRecoilValue(homePageState);
  const homepage = useRecoilValue(userTeamHomepageState);
  const userHomepageIsValid = useRecoilValue(homepageIsValidState);

  // `userHomepageIsValid` either true, false or undefined (when user has not setup a homepage in preferences)
  if (userHomepageIsValid && homepage) {
    return <Redirect to={homepage} />;
  }

  // If user does not have access to dashboard or search, homePageState returns message 'Access Denied'
  // this check is to validate the message and display error, otherwise it will contain a route and user is directed to the corresponding page
  return defaultHomepage === K.ACCESS_DENIED ? <AccessDeniedError /> : <Redirect to={defaultHomepage} />;
}

export default RedirectToHomePage;
